module.exports = __webpack_public_path__ + "static/media/HAUX_NUTRICAO_7.76b92086.pdf";